import React from 'react'
import Highcharts from 'highcharts'
import HT from 'highcharts/modules/timeline'
import HighchartsReact from 'highcharts-react-official'
import CountingMethod from './../../utils/getCountingMethod'

import Spinner from '../Loader/Spinner'

import getPieChartOptions from './getPieChartOptions'

import styles from './PieChartDisplay.module.scss'
if (typeof Highcharts === 'object') {
  HT(Highcharts)
}

const PieChartDisplay = ({
  entity,
  data,
  chartName,
  locationName
}) => {
  let colors=[
      '#E5E5E6',
      '#0F5044',
      '#1D7D6E',
      '#46AA99',
      '#8ED6C6',
      '#E5FDF7',
      '#E5E5E6'
    ]
  let borderColors=['#4B4D4F','#15A796','#15A796','#15A796','#15A796','#15A796','#4B4D4F']
  var finalData = []
  var med_data = ''
  if (chartName === 'providerTypeChart') {    
    med_data = data
  }

  var chart_data = []
  var val_sum = 0
  if (chartName === 'providerTypeChart') {
    if (med_data!=null || med_data !=undefined)
    {
       //med_data.sort((a, b) => (parseFloat(a.total_count) < parseFloat(b.total_count)) ? 1: -1);
    
    
    med_data.forEach((data_val) => {
      if(parseInt(data_val.total_count)>-1)
      val_sum =  parseInt(data_val.group_count)
    })
    med_data.forEach((data_val,index) => {
      let obj={
          name: data_val.category_name,
          y: data_val.total_count,
          color:colors[data_val.rank],
          borderColor:borderColors[data_val.rank],
          borderWidth:'2px', 
      }
      if(data_val.total_count>-1)
      chart_data.push(obj)
    })
  }
  } 


  finalData.push({
    name: 'total_count',
    data: val_sum
  })
  finalData.push({ name: 'data', data: chart_data })
  const chartOptions = getPieChartOptions(
    finalData,
    locationName
  )
  return chartOptions ? (
    <div className={styles.base}>
      <div className={styles.body}>
        <HighchartsReact
          containerProps={{
            style: {
              fontFamily: 'Optum Sans',
              height: '100%',
              width: '100%',
              position: 'relative',
            },
          }}
          highcharts={Highcharts}
          options={chartOptions}
          updateArgs={[true, true, true]}
          allowChartUpdate
        />
      </div>
    </div>
  ) : (
    <Spinner />
  )
}

export default PieChartDisplay
